/*=============================================== Youtube ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import { convertYoutube, stringifyPx } from "js-utils-julseb";
/*==================== Component ====================*/
var Youtube = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, aspectRatio = _a.aspectRatio, props = __rest(_a, ["src", "width", "height", "aspectRatio"]);
    return (React.createElement(Container, __assign({ src: convertYoutube(src), frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true, "$width": width, "$height": height, "$aspectRatio": aspectRatio }, props)));
};
export default Youtube;
/*==================== Styles ====================*/
var Container = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    aspect-ratio: ", ";\n"], ["\n    width: ", ";\n    height: ", ";\n    aspect-ratio: ", ";\n"])), function (_a) {
    var $width = _a.$width;
    return ($width ? stringifyPx($width) : "100%");
}, function (_a) {
    var $height = _a.$height;
    return $height;
}, function (_a) {
    var $aspectRatio = _a.$aspectRatio, $height = _a.$height;
    return $aspectRatio ? $aspectRatio : !$height && !$aspectRatio ? "16/9" : "";
});
var templateObject_1;
